import { Button, DataTable, ErrorBoundary, Icons } from '@components'
import { useCallback, useHistory, useRef, useRequest, useTranslation, useTableLocationParams } from '@hooks'
import { api, message } from '@services'
import { TMaterial, TFilteredRequest, TResponseWithFilters } from '@typings'
import * as React from 'react'
import { columns } from './MaterialsList.tableOptions'

const MaterialsListScreen: React.FC<TProps> = () => {
	// Main screen data.
	const { t } = useTranslation()
	const history = useHistory()
	const tableRef = useRef()
	const [searchParams, setSearchParams] = useTableLocationParams()

	// Obtain articles.
	const { data: { data: materials, meta } = {}, fetch, fetching, fetched } = useRequest<
		TResponseWithFilters<TMaterial[]>,
		TFilteredRequest & Partial<TMaterial>
	>(
		{
			request: () => api.getMaterialsTable(searchParams),
			onError: (error) => message.error(error.message),
		},
		[searchParams],
	)

	// Actions.
	const goToAddMaterial = useCallback(() => history.push('/materials/add'), [])

	return (
		<ErrorBoundary>
			<DataTable<TMaterial, Partial<TMaterial>>
				ref={tableRef}
				loading={fetching}
				columns={columns}
				dataSource={materials}
				meta={meta}
				searchInputValues={searchParams}
				autoFetchOnMount={false}
				onChange={setSearchParams}
				HeaderComponent={
					<Button type="primary" icon={<Icons.PlusCircleOutlined />} size="middle" onClick={goToAddMaterial}>
						{t('Add material')}
					</Button>
				}
			/>
		</ErrorBoundary>
	)
}

type TProps = {
	/** */
}

export default MaterialsListScreen
